<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom ou Titre</span>
      </div>
      <input :value="championnat.nom.toUpperCase()" disabled type="text" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="championnat.date_creation"
             name="championnat_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="championnat.temps_creation"
             name="championnat_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="championnat.date_modification"
             name="championnat_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="championnat.temps_modification"
             name="championnat_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    championnat: {
      type: Object
    }
  },
  data(){
    return{}
  },
components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/championnats/components/Read.vue